import { render, staticRenderFns } from "./DocumentTypes.vue?vue&type=template&id=02a8c402"
import script from "./DocumentTypes.vue?vue&type=script&lang=ts"
export * from "./DocumentTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports